// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_h6-0";
export var discountCodeInput = "_h6-1";